<template>
  <div>
    <div v-if="showloading">
      <loader-appie />
    </div>
    <div v-else>
      <!--====== PRELOADER PART START ======-->

      <!-- <div class="loader-wrap">
          <div class="preloader"><div class="preloader-close">Preloader Close</div></div>
          <div class="layer layer-one"><span class="overlay"></span></div>
          <div class="layer layer-two"><span class="overlay"></span></div>        
          <div class="layer layer-three"><span class="overlay"></span></div>        
      </div> -->

      <!--====== PRELOADER PART ENDS ======-->

      <!--====== OFFCANVAS MENU PART START ======-->

      <sidebar-home-one
        :sidebar="sidebar"
        @toggleSidebar="toggleSidebar"
        :menuItems="navs"
      />

      <!--====== OFFCANVAS MENU PART ENDS ======-->

      <!--====== PART START ======-->

      <header-home-one @toggleSidebar="toggleSidebar" :menuItems="navs" />

      <!--====== PART ENDS ======-->

      <!--====== APPIE HERO PART START ======-->

      <hero-home-one
        slogan="A digital cooperative system offering a smooth and effortless user experience!"
        description="We've created an innovative system designed to elevate cooperatives to unprecedented levels. It's intuitive, convenient, and immediately accessible, requiring minimal setup."
        first_button_content="Request Demo"
        first_button_icon="fal fa-long-arrow-right"
        second_button_content="Watch Video"
        second_button_icon="far fa-play-circle"
      />

      <!--====== APPIE HERO PART ENDS ======-->

      <!--====== APPIE SERVICES PART START ======-->

      <services-home-one section_heading="Why Use Verde?" />

      <!--====== APPIE SERVICES PART ENDS ======-->

      <!--====== APPIE PROJECT PART ENDS ======-->

      <!--====== APPIE FOOTER PART START ======-->

      <footer-home-one />

      <!--====== APPIE FOOTER PART ENDS ======-->

      <!--====== APPIE BACK TO TOP PART ENDS ======-->
      <div class="back-to-top">
        <a href="#"><i class="fal fa-arrow-up"></i></a>
      </div>
      <!--====== APPIE BACK TO TOP PART ENDS ======-->
    </div>
  </div>
</template>
<script>
import testmonialAvater from "@/assets/images/testimonial-user.png";
import traffic_thumb from "@/assets/images/traffic.png";
import HeaderHomeOne from "./HeaderHomeOne.vue";
import SidebarHomeOne from "./SidebarHomeOne.vue";
import HeroHomeOne from "./HeroHomeOne.vue";
import FooterHomeOne from "./FooterHomeOne.vue";
import ServicesHomeOne from "./ServicesHomeOne.vue";
import LoaderAppie from "../LoaderAppie.vue";
export default {
  name: "HomeOne",
  props: {
    rtl: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HeaderHomeOne,
    SidebarHomeOne,
    HeroHomeOne,
    FooterHomeOne,
    LoaderAppie,
    ServicesHomeOne,
  },
  data() {
    return {
      traffic_thumb: traffic_thumb,
      testmonialAvater: testmonialAvater,
      sidebar: false,
      showloading: true,
      navs: [
        {
          name: "Home",
          path: "/",
        },
        {
          name: "Solutions",
          childrens: [
            {
              name: "Verde Co-op",
              path: "/co-op",
            },
            {
              name: "Verde SCF",
              path: "/scf",
            },
            // {
            //   name: "Verde Power",
            //   path: "/power",
            // },
            {
              name: "Verde Tech",
              path: "/tech",
            },
          ],
        },
        {
          name: "About Us",
          path: "/about-us",
        },
      ],
    };
  },
  created() {
    if (!this.rtl) {
      this.preLoading();
    } else {
      this.showloading = false;
    }
    document.addEventListener("scroll", this.topToBottom);
  },

  methods: {
    preLoading() {
      setTimeout(() => {
        this.showloading = false;
      }, 2000);
    },
    topToBottom() {
      const result = document.querySelector(".back-to-top");
      if (
        document.body.scrollTop > window.innerHeight ||
        document.documentElement.scrollTop > window.innerHeight
      ) {
        result.style.display = "block";
      } else {
        result.style.display = "none";
      }
    },
    toggleSidebar() {
      this.sidebar = !this.sidebar;
    },
  },
};
</script>

<style></style>
